import { config } from '@src/tracker/create-tracker';

export const DOWNLOAD_QR_POSITION = {
  HOME: '首页',
  HOME_SIDE: '首页侧边',
  INNER_SIDE: '内页侧边'
};

function getTranckUrl(targetUrl, sendParms) {
  const url_track = 'https://xfe.seasungame.com/m/2021/07/22/qr-track/index.html';
  const trackData = {
    stReport: {
      constructorParams: {
        ...config,
        projectIdentifier: config.identify
      },
      sendParams: sendParms
    }
  };
  const params = ['track-data=' + encodeURIComponent(JSON.stringify(trackData)), 'redirect-url=' + encodeURIComponent(targetUrl)];
  // 生成最终的地址
  const finalUrl = url_track + '?' + params.join('&');
  return finalUrl;
}
function getIframeUrl(finalUrl) {
  const requestQueryString = encodeURIComponent(
    JSON.stringify({
      value: finalUrl, // finalUrl 代指埋点最终生成的 url 地址
      short: true // short 为 true 代表使用短链
    })
  );
  return '//zhcdn01.xoyo.com/xassets/iframe/qr/0.0.x/index.html?' + requestQueryString;
}

function getDownloadQrIframeUrl(targetUrl, title) {
  const normalizedTargetUrl = typeof targetUrl === 'string' ? targetUrl.trim() : '';
  if (!normalizedTargetUrl) return '';

  const trackUrl = getTranckUrl(normalizedTargetUrl, {
    eventName: 'scan_download_game',
    eventDescription: '扫码下载',
    eventDataValue: { title }
  });
  return getIframeUrl(trackUrl);
}

export { getTranckUrl, getIframeUrl, getDownloadQrIframeUrl };
